<script lang="ts" setup></script>
<template>
	<main class="min-h-dvh flex justify-center items-center bg-white px-0 py-0 md:bg-gray-300 md:px-4 md:py-8">
		<div class="w-full bg-white md:max-w-[430px] md:rounded-2xl md:p-8 md:shadow-lg">
			<slot />
		</div>
	</main>
</template>
